// extracted by mini-css-extract-plugin
module.exports = {"calendar":"Calendar_calendar_2VnvZ"};